import React from 'react';

import css from './Checkbox.module.scss';

interface Props {
  id: string;
  label?: JSX.Element;
  checked?: boolean;
  disabled?: boolean;
  'data-e2e'?: string;
  onChange: () => void;
  onClick?: () => void;
}

const Checkbox = (props: Props) => (
  <div className={css.checkboxWrapper}>
    <input
      className={css.inpcbx}
      id={props.id}
      checked={props.checked}
      disabled={props.disabled}
      onChange={props.onChange}
      onClick={props.onClick}
      type="checkbox"
      data-testid="checkbox"
    />
    <label className={css.cbx} htmlFor={props.id}>
      <span className={css.fakeCheckbox} data-e2e={props['data-e2e']}>
        <svg width="14px" height="10px" viewBox="0 0 12 10">
          <polyline points="1.5 6 4.5 9 10.5 1" />
        </svg>
      </span>
      <span className={css.labelText}>{props.label}</span>
    </label>
  </div>
);

export default Checkbox;
